/* eslint-disable func-style */
import React, { useCallback, useState } from 'react';
import { Button } from 'semantic-ui-react';
import csrfToken from '../../util/csrfToken.js';
import Confirmation from '../Confirmation.jsx';

const csrf = csrfToken();

async function submitAction(url, method = 'PUT', body = {}) {
  let response = await fetch(url, {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...csrf.header,
    },
    body: JSON.stringify(body),
  });

  response = response.ok ? response : Promise.reject(response);
  return response.json();
}

export default function ActionButton({
  requestMethod = 'PUT',
  onChange,
  path,
  onError,
  children,
  confirmationMessage,
  askConfirmation = false,
  className = '',
  ...props
}) {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleSubmit = useCallback(() => {
    submitAction(path, requestMethod)
      .then((data) => onChange(data))
      .catch((errorResponse) => {
        // eslint-disable-next-line no-console
        console.log(errorResponse.status, errorResponse.statusText);

        if (onError) {
          // eslint-disable-next-line max-nested-callbacks
          errorResponse.json().then((error) => onError(error));
        }
      });
  }, [path, onChange, onError]);

  const confirmAction = useCallback(
    (e) => {
      askConfirmation ? setShowConfirmation(true) : handleSubmit(e);
    },
    [handleSubmit],
  );

  return (
    <Button
      {...props}
      compact
      as={'a'}
      className={className}
      onClick={confirmAction}
    >
      <Confirmation
        customConfirmationHandler={handleSubmit}
        msg={confirmationMessage}
        show={showConfirmation}
        onClose={() => setShowConfirmation(false)}
      />

      {children}
    </Button>
  );
}
